<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </template>
        <v-list width="250" dense>
            <v-list-item v-for="(item, index) in filteredItems" :key="index" :disabled="!item.ability" @click="item.callback" link>
                <v-list-item-icon>
                    <v-icon :disabled="!item.ability || item.disabled">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "PMenu",
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        filteredItems() {
            return this.items.filter(each => each.display !== false);
        }
    }
};
</script>
